module.exports = __webpack_public_path__ + "img/dots_lbb5.65ae4880.png";